// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1978K","question":"Question_question__coxb_","description":"Question_description__JazIz"};